import { ReservedListTypeEnum } from "@simplyk/common";

interface OrderableList {
  lastEditedAtUtc: Date | string;
  reservedListType?: string | null;
}

// Communication-preference lists compete with static lists for the few suggestion slots; the rest of the
// filter lists keep the server order behind them.
export const orderListsForSuggestions = <T extends OrderableList>(staticLists: T[], filterLists: T[]): T[] => {
  const isCommunicationPreference = (list: T) => list.reservedListType === ReservedListTypeEnum.CommunicationPreference;

  return [
    ...[...staticLists, ...filterLists.filter(isCommunicationPreference)].sort(
      (a, b) => new Date(b.lastEditedAtUtc).getTime() - new Date(a.lastEditedAtUtc).getTime()
    ),
    ...filterLists.filter((list) => !isCommunicationPreference(list)),
  ];
};
